import React, { memo, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import {
  Alert,
  Button,
  Skeleton,
  Stack,
  Card,
  Typography,
  Chip,
  Divider,
  CardHeader,
  CardContent,
  Link,
  Icon
} from 'investira.react.components';
import { displays } from 'investira.react.lib';
import { formats } from 'investira.sdk';
import {
  CorrelacaoMatriz,
  CorrelacaoHeatMap,
  AtivoInformacoes
} from '../../../components/organisms';
import { PessoaImage } from '../../../components/molecules';
import services from '../../../services';
import utils from '../../../utils';

const ComparadorAtivosInformacao = memo(({ ativos = [] }) => {
  return (
    <Stack direction="row" gap={1} data-comparador-header-scroll="horizontal">
      <Card
        sx={{
          flex: { xs: '0 0 240px', md: 1 },
          display: 'flex',
          flexDirection: 'column'
        }}>
        <CardHeader
          title={
            <Stack direction="row" gap={1} alignItems="center">
              <Typography
                variant="subtitle1"
                component="h3"
                color="textPrimary"
                sx={{ fontWeight: 600 }}
                noWrap>
                Informações do ativo
              </Typography>
            </Stack>
          }
        />
        <CardContent sx={{ pt: 0 }}>
          <Stack direction="row" gap={2}>
            {ativos.map((pAtivo, pIndex) => {
              return (
                <React.Fragment key={pIndex}>
                  {pIndex > 0 ? (
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{ borderColor: 'secondary.light' }}
                    />
                  ) : null}
                  <Stack flex={1}>
                    <Stack>
                      <PessoaImage
                        logoPessoaId={pAtivo.logo_pessoa_id}
                        alt={pAtivo.pessoa_fantasia}
                        hasLogo={pAtivo.logo_ok}
                        size={36}
                      />
                    </Stack>

                    <AtivoInformacoes ativo={pAtivo} variant="onlyContent" />
                    <Stack direction="row" justifyContent="flex-end">
                      <Button
                        component={Link}
                        title={pAtivo.ativo}
                        endIcon={<Icon iconName="arrow-next" size={12} />}
                        size="small"
                        href={`/ativos/fundos/${pAtivo.ifeed_ativo_id}`}
                        sx={{ px: 2 }}
                        rel="search"
                        target="_blank">
                        Mais detalhes
                      </Button>
                    </Stack>
                  </Stack>
                </React.Fragment>
              );
            })}
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
});

export default ComparadorAtivosInformacao;
